import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SearchSuggestionType } from 'constants/search';
export const transformSearchSuggestion = suggestion => {
  const {
    id,
    title,
    params
  } = suggestion;
  const commonSuggestionFields = {
    id,
    title,
    params
  };

  if ('filters' in suggestion) {
    return _objectSpread(_objectSpread({}, commonSuggestionFields), {}, {
      subtitle: suggestion.subtitle,
      query: suggestion.filters.search_text,
      filters: {
        query: suggestion.filters.search_text,
        catalogIds: [suggestion.filters.catalog_id]
      },
      type: SearchSuggestionType.Scoped
    });
  }

  const querySuggestionTypes = [SearchSuggestionType.Brand, SearchSuggestionType.Catalog, SearchSuggestionType.Multiword];
  return _objectSpread(_objectSpread({}, commonSuggestionFields), {}, {
    query: title,
    typeId: suggestion.suggestion_id.toString(),
    type: querySuggestionTypes[suggestion.suggestion_type]
  });
};
export const transformSearchSuggestions = suggestions => suggestions.map(transformSearchSuggestion);